import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const MovingTruckIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="37"
    height="27"
    viewBox="0 0 37 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <g clipPath="url(#clip0_6894_39180)">
      <path
        d="M31.2066 5.88782H25.4132V10.8968C25.4132 9.01604 24.1374 7.49446 22.5591 7.49446H19.7049H7.57007C6.76675 7.49446 5.99178 7.91975 5.47199 8.65691L2.47607 12.8814V19.79C2.47607 21.6707 3.75194 23.1923 5.33022 23.1923H6.7573H6.82346C7.11643 24.8651 8.56241 26.1315 10.3297 26.1315C12.097 26.1315 13.543 24.8745 13.836 23.1923H13.9777H22.6252H22.6914C22.9844 24.8651 24.4303 26.1315 26.1977 26.1315C27.965 26.1315 29.4109 24.8745 29.7039 23.1923H35.3272C36.1966 23.1923 36.9905 22.474 36.9905 21.5289V11.6812C37 8.5057 34.4577 5.88782 31.2066 5.88782Z"
        fill="#F0CBA7"
      />
      <path
        d="M20.3004 6.04855H12.6641C12.3712 6.04855 12.1254 5.83119 12.0782 5.54766L11.8892 4.3096C11.8703 4.17729 11.8986 4.03553 11.9648 3.92212L14.0629 0.292999C14.2235 0.00947383 14.5827 -0.0850345 14.8662 0.0756296L21.3589 3.79926C21.5007 3.88431 21.6046 4.02608 21.6424 4.18674C21.6802 4.34741 21.6424 4.51752 21.5385 4.65928L20.9525 5.4626C20.9336 5.57601 20.8769 5.67997 20.8013 5.75558C20.6973 5.93514 20.5083 6.04855 20.3004 6.04855ZM13.1745 4.8672H19.9318L20.2059 4.49862L14.8 1.39875L13.0989 4.33795L13.1745 4.8672Z"
        fill="#226937"
      />
      <path
        d="M11.8041 6.04851H4.46083C4.1584 6.04851 3.91268 5.83114 3.87488 5.52871L3.40234 1.80509C3.36453 1.48376 3.5819 1.19078 3.90323 1.14353L11.823 -2.17683e-05C12.1349 -0.0472759 12.4373 0.170093 12.494 0.491421L13.0705 4.12054C13.0894 4.25285 13.0705 4.37571 13.0044 4.48912L12.3334 5.72718C12.22 5.92565 12.0215 6.04851 11.8041 6.04851ZM4.98062 4.86716H11.4544L11.8608 4.11109L11.4072 1.25694L4.64039 2.23983L4.98062 4.86716Z"
        fill="#226937"
      />
      <path
        d="M4.87663 21.7464H3.44955C1.54994 21.7464 0 19.9507 0 17.7487V10.8401C0 10.7173 0.0378033 10.5944 0.11341 10.4999L3.10932 6.27536C3.74253 5.37753 4.68761 4.86719 5.6894 4.86719H20.6784C22.578 4.86719 24.128 6.66285 24.128 8.86489V16.0475C24.128 16.3783 23.8633 16.6335 23.542 16.6335C23.2207 16.6335 22.9561 16.3688 22.9561 16.0475V8.86489C22.9561 7.31495 21.9354 6.04854 20.6879 6.04854H5.67995C5.06564 6.04854 4.47969 6.37932 4.06386 6.95582L1.18135 11.0291V17.7487C1.18135 19.2986 2.20204 20.565 3.44955 20.565H4.87663C5.19796 20.565 5.46258 20.8296 5.46258 21.151C5.46258 21.4723 5.19796 21.7464 4.87663 21.7464Z"
        fill="#EA7200"
      />
      <path
        d="M33.4465 21.7464H27.8138C27.4924 21.7464 27.2278 21.4818 27.2278 21.1605C27.2278 20.8392 27.4924 20.5745 27.8138 20.5745H33.4465C33.9663 20.5745 34.5239 20.1398 34.5239 19.4971V12.2862H23.5231C23.2018 12.2862 22.9371 12.0215 22.9371 11.7002V3.85602C22.9371 3.52524 23.2018 3.26062 23.5231 3.26062H29.3164C32.8322 3.26062 35.6958 6.12422 35.6958 9.63993V19.4782C35.7052 20.7352 34.694 21.7464 33.4465 21.7464ZM24.1185 11.0954H34.5239V9.63993C34.5239 6.76688 32.1895 4.44197 29.3259 4.44197H24.1279V11.0954H24.1185Z"
        fill="#EA7200"
      />
      <path
        d="M24.3169 24.6856C22.0204 24.6856 20.1586 22.8144 20.1586 20.5273C20.1586 18.2402 22.0298 16.3689 24.3169 16.3689C26.6135 16.3689 28.4753 18.2402 28.4753 20.5273C28.4753 22.8144 26.6135 24.6856 24.3169 24.6856ZM24.3169 17.5408C22.6441 17.5408 21.3399 18.8545 21.3399 20.5178C21.3399 22.1812 22.6441 23.4948 24.3169 23.4948C25.9897 23.4948 27.2939 22.1812 27.2939 20.5178C27.2939 18.8545 25.9897 17.5408 24.3169 17.5408Z"
        fill="#EA7200"
      />
      <path
        d="M8.44901 24.6856C6.15246 24.6856 4.29065 22.8144 4.29065 20.5273C4.29065 18.2402 6.16191 16.3689 8.44901 16.3689C10.7456 16.3689 12.6074 18.2402 12.6074 20.5273C12.6074 22.8144 10.7456 24.6856 8.44901 24.6856ZM8.44901 17.5408C6.77622 17.5408 5.472 18.8545 5.472 20.5178C5.472 22.1812 6.77622 23.4948 8.44901 23.4948C10.1218 23.4948 11.426 22.1812 11.426 20.5178C11.426 18.8545 10.1218 17.5408 8.44901 17.5408Z"
        fill="#EA7200"
      />
      <path
        d="M20.7446 21.7464H12.0971C11.7757 21.7464 11.5111 21.4817 11.5111 21.1604C11.5111 20.8391 11.7757 20.5745 12.0971 20.5745H20.7446C21.0659 20.5745 21.3305 20.8391 21.3305 21.1604C21.3305 21.4817 21.0753 21.7464 20.7446 21.7464Z"
        fill="#EA7200"
      />
      <path
        d="M18.656 14.5921C18.3347 14.5921 18.0701 14.3275 18.0701 14.0062V9.01613C18.0701 8.68535 18.3347 8.43018 18.656 8.43018C18.9773 8.43018 19.242 8.6948 19.242 9.01613V14.0062C19.2514 14.3275 18.9868 14.5921 18.656 14.5921Z"
        fill="#226937"
      />
      <path
        d="M13.4391 14.5921C13.1178 14.5921 12.8531 14.3275 12.8531 14.0062V9.01613C12.8531 8.68535 13.1178 8.43018 13.4391 8.43018C13.7604 8.43018 14.0251 8.6948 14.0251 9.01613V14.0062C14.0345 14.3275 13.7699 14.5921 13.4391 14.5921Z"
        fill="#226937"
      />
      <path
        d="M8.2317 14.5921C7.91038 14.5921 7.64575 14.3275 7.64575 14.0062V9.01613C7.64575 8.68535 7.91038 8.43018 8.2317 8.43018C8.55303 8.43018 8.81765 8.6948 8.81765 9.01613V14.0062C8.81765 14.3275 8.55303 14.5921 8.2317 14.5921Z"
        fill="#226937"
      />
    </g>
    <defs>
      <clipPath id="clip0_6894_39180">
        <rect width="37" height="26.1221" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
));
